import { Component, OnInit, Input } from '@angular/core';
import { typedati, Datipreventivo } from '../model/datipreventivo';

@Component({
  selector: 'app-comparatoregas',
  templateUrl: './comparatoregas.component.html',
  styleUrls: ['./comparatoregas.component.scss']
})
export class ComparatoregasComponent implements OnInit {
  private _dati: Datipreventivo;

  static _consumoannuonoto: string;
  static _zona: string;
  static _consumoannuoManuale: number;
  static _consumoannuopersone: number;
  static _consumoannuometri: number;
  static _riscaldamento: boolean;
  static _cucina: boolean;
  static _produzioneAcquacalda: boolean;

  set modalitapagamento(dato: string) {
    this._dati.datiextra.filter(o => o.idDato == 4)[0].valore = dato;
  }
  get modalitapagamento() {
    return this._dati.datiextra.filter(o => o.idDato == 4)[0].valore;
  }

  set consumoannuopersone(dato: string) {
    ComparatoregasComponent._consumoannuopersone = +dato;
    ComparatoregasComponent._consumoannuoManuale = 0;
    this.consumoannuocalcolo();
  }
  get consumoannuometri() {
    return ComparatoregasComponent._consumoannuometri.toString();
  }

  set consumoannuometri(dato: string) {
    ComparatoregasComponent._consumoannuometri = +dato;
    ComparatoregasComponent._consumoannuoManuale = 0;
    this.consumoannuocalcolo();
  }
  get consumoannuopersone() {
    return ComparatoregasComponent._consumoannuopersone.toString();
  }

  set riscaldamento(dato: boolean) {
    ComparatoregasComponent._riscaldamento = dato;
    ComparatoregasComponent._consumoannuoManuale = 0;
    this.consumoannuocalcolo();
  }
  get riscaldamento() {
    return ComparatoregasComponent._riscaldamento;
  }

  set cucina(dato: boolean) {
    ComparatoregasComponent._cucina = dato;
    ComparatoregasComponent._consumoannuoManuale = 0;
    this.consumoannuocalcolo();
  }
  get cucina() {
    return ComparatoregasComponent._cucina;
  }

  set produzioneAcquacalda(dato: boolean) {
    ComparatoregasComponent._produzioneAcquacalda = dato;
    ComparatoregasComponent._consumoannuoManuale = 0;
    this.consumoannuocalcolo();
  }
  get produzioneAcquacalda() {
    return ComparatoregasComponent._produzioneAcquacalda;
  }

  set consumoannuonoto(dato: string) {
    ComparatoregasComponent._consumoannuonoto = dato;
    if (dato == "true") {
      ComparatoregasComponent._riscaldamento = false;
      ComparatoregasComponent._cucina = false;
      ComparatoregasComponent._produzioneAcquacalda = false;


    }
    else {
      ComparatoregasComponent._consumoannuoManuale = 0;
    }
    this.consumoannuocalcolo();
  }
  get consumoannuonoto() {
    return ComparatoregasComponent._consumoannuonoto;
  }

  set consumoannuo(dato: string) {
    this._dati.datiextra.filter(o => o.idDato == 1)[0].valore = dato;
    ComparatoregasComponent._consumoannuoManuale = +dato;
    ComparatoregasComponent._consumoannuopersone = 0;
    ComparatoregasComponent._consumoannuometri = 0;
    ComparatoregasComponent._riscaldamento = false;
    ComparatoregasComponent._cucina = false;
    ComparatoregasComponent._produzioneAcquacalda = false;

  };
  get consumoannuo() {
    this.consumoannuocalcolo();
    return this._dati.datiextra.filter(o => o.idDato == 1)[0].valore  //this.dati.datiextra.filter(o => o.idDato == 1)[0].valore;

  };
  get consumoannuoelettrodomestici() {
    return (ComparatoregasComponent._consumoannuometri * (this.riscaldamento ? 1 : 0)) + (100 * (this.cucina ? 1 : 0));
  }

  private consumoannuocalcolo() {
    if (this._dati != null)
      this._dati.datiextra.filter(o => o.idDato == 1)[0].valore = (ComparatoregasComponent._consumoannuoManuale + this.consumoannuoelettrodomestici + (ComparatoregasComponent._consumoannuopersone * (this.produzioneAcquacalda ? 1 : 0))).toString();
    else {
      ComparatoregasComponent._consumoannuopersone = 0;
      ComparatoregasComponent._consumoannuometri = 0;
    }
  }

  set tipocontratto(dato: string) {
    this._dati.datiextra.filter(o => o.idDato == 3)[0].valore = dato;
  };
  get tipocontratto() {
    return this._dati.datiextra.filter(o => o.idDato == 3)[0].valore;
  };

  set zona(dato: string) {
    ComparatoregasComponent._zona = dato;
    var zonagas = "1";
    switch (true) {
      case (dato == "8" || dato == "12" || dato == "18"):
        zonagas = "1";
        break;

      case (dato == "5" || dato == "6" || dato == "9" || dato == "16" || dato == "19"):
        zonagas = "2";
        break;
      case (dato == "10" || dato == "15" || dato == "17"):
        zonagas = "3";
        break;
      case (dato == "1" || dato == "2" || dato == "11" || dato == "13"):
        zonagas = "4";
        break;
      case (dato == "4" || dato == "7"):
        zonagas = "5";
        break;
      case (dato == "3" || dato == "14"):
        zonagas = "6";
        break;
    }

    this._dati.datiextra.filter(o => o.idDato == 2)[0].valore = zonagas;
  };
  get zona() {
    return ComparatoregasComponent._zona;
  };
  constructor() {
    // this.consumoannuonoto=true;


  }

  @Input('dati') set dati(dato: Datipreventivo) {
    this._dati = dato;
    if (ComparatoregasComponent._consumoannuopersone == null) {
      ComparatoregasComponent._consumoannuopersone =0;
      ComparatoregasComponent._consumoannuoManuale=  +dato.datiextra.filter(o => o.idDato == 1)[0].valore
      ComparatoregasComponent._consumoannuometri = 0;
      ComparatoregasComponent._consumoannuonoto = "true";
      ComparatoregasComponent._zona="8";
    }
  }
  get dati(): Datipreventivo {
    return this._dati;
  }


  ngOnInit() {


  }



}




// WEBPACK FOOTER //
// ./src/app/comparatoregas/comparatoregas.component.ts